// MUTATIONS
export const SET_COMPANIES = 'setCompanies';
export const SET_CURRENT_COMPANY = 'setCurrentCompany';
export const SET_CURRENT_COMPANY_USERS = 'setCurrentCompanyUsers';
export const SET_CURRENT_COMPANY_USERS_GROUPS = 'setCurrentCompanyUsersGroups';
export const SET_CURRENT_COMPANY_OVP_JOB_CONDITIONS = 'setCurrentCompanyOvpJobConditions';
export const SET_CURRENT_COMPANY_JOB_TITLES = 'setCurrentCompanyJobTitles';
export const SET_IS_LOADING = 'isLoading';
export const SET_IS_ACTIVE_REQUEST = 'setIsActiveRequest';

// ACTIONS
export const ACTION_GET_COMPANIES = 'getCompanies';
export const ACTION_GET_SINGLE_COMPANY = 'getSingleCompany';
export const ACTION_CREATE_COMPANY = 'createCompany';
export const ACTION_UPDATE_COMPANY = 'updateCompany';
export const ACTION_REMOVE_COMPANY = 'removeCompany';

// GETTERS
export const GET_COMPANIES = 'companies';
export const GET_CURRENT_COMPANY = 'currentCompany';
export const GET_IS_LOADING = 'isLoading';
export const GET_IS_ACTIVE_REQUEST = 'isActiveRequest';